import WizardPanel from './WizardPanel';

export default WizardPanel;
